var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user !== '')?_c('div',[_c('v-row',[_c('v-col',[_vm._v(" "+_vm._s(_vm.Usuario)+" "),_c('v-btn',{attrs:{"color":"secondary","x-small":"","dark":"","depressed":""},on:{"click":_vm.salir}},[_vm._v("Salir")])],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }